const createValidator = validationMap => {

    const validateValue = (label, value) => {
        const labelValidations = validationMap[label];

        return (
            !!labelValidations &&
            labelValidations.reduce(
                (acc, current) => acc || (!current.validate(value) && current.errorMessage),
                false
            )
        );
    };

    const checkErrors = form => {
        const keys = Object.keys(validationMap);
        return keys.reduce((acc, label) => {
            const error = validateValue(label, form[label]);
            if (error) {
                acc[label] = error;
            }
            return acc;
        }, {});
    };

    const areAnyErrorInValues = values => {
        const valuesArray = Object.entries(values);
        const error = valuesArray.reduce((acc, [label, value]) => acc || validateValue(label, value), false);
        return !!error;
    };

    return {
        areAnyErrorInValues,
        checkErrors,
        validateValue
    };
};

export default createValidator;
